const productData = [
  {
    id: 1,
    name: 'Rhone Linear Chandelier, 48" Width in Metal Shades',
    category: "Lighting",
    price: "1299.00",
    reviews: "1842",
    rating: "4.9",
    image: "/img/101.jpg",
    images: ["/img/101.jpg"],
    description: [
      "Dramatic linear chandelier with metal shades finished for a warm, aged patina.",
      "Generous 48\" width designed for over-island or dining installation with balanced illumination.",
      "Hand-assembled components and durable metal canopy for secure ceiling mounting.",
      "Complements both traditional and transitional interiors with refined proportions.",
      "Recommended for medium to large rooms; dimmable with compatible dimmers.",
    ],
    Features: [
      "48\" overall width",
      "Metal shades with antique finish",
      "Hardwired installation with canopy",
      "Dimmable with compatible dimmers",
      "Includes mounting hardware and instructions",
    ],
  },
  {
    id: 2,
    name: "Mavis Semi-Flush Mount",
    category: "Lighting",
    price: "249.00",
    reviews: "3210",
    rating: "4.8",
    image: "/img/102.jpg",
    images: ["/img/102.jpg"],
    description: [
      "Low-profile semi-flush ceiling fixture ideal for entryways and low ceilings.",
      "Softly diffused glass shade provides even ambient light without glare.",
      "Classic silhouette updated with modern finishes to suit varied décors.",
      "Easy to mount with a simple canopy and secure hardware included.",
      "Energy-efficient when used with LED bulbs.",
    ],
    Features: [
      "Semi-flush mount design",
      "Opal glass diffuser",
      "Compatible with LED bulbs",
      "Multiple finish options",
      "Includes mounting hardware",
    ],
  },
  {
    id: 3,
    name: "Amalie Sconce",
    category: "Lighting",
    price: "199.00",
    reviews: "1120",
    rating: "4.7",
    image: "/img/103.jpg",
    images: ["/img/103.jpg"],
    description: [
      "Elegant wall sconce with an arced arm and linen-style shade for soft task light.",
      "Designed for symmetry flanking mirrors or to add layered ambient lighting.",
      "Solid metal construction and a timeless profile for long-lasting style.",
      "Hardwired installation with clear instructions and mounting hardware.",
      "Suitable for many indoor applications including baths and hallways.",
    ],
    Features: [
      "Metal arm and backplate",
      "Fabric shade for warm light",
      "LED-compatible socket",
      "Suitable for bathroom-rated locations (check spec)",
      "Includes mounting hardware",
    ],
  },
  {
    id: 4,
    name: 'Andra Pendant, 14" Width',
    category: "Lighting",
    price: "349.00",
    reviews: "2004",
    rating: "4.8",
    image: "/img/104.jpg",
    images: ["/img/104.jpg"],
    description: [
      "Hand-finished pendant with a 14\" shade that's perfect over kitchen islands and tables.",
      "Adjustable cord length allows tuning the drop for your ceiling height.",
      "Brass accents and a soft matte shade balance modern and classic sensibilities.",
      "Pairs well in multiples for layered lighting schemes or singly as a focal pendant.",
      "Designed for residential and light commercial settings.",
    ],
    Features: [
      "14\" diameter shade",
      "Adjustable suspension length",
      "Brass hardware accents",
      "Compatible with LED lamping",
      "Includes canopy and mounting hardware",
    ],
  },
  {
    id: 5,
    name: "Freya Sconce",
    category: "Lighting",
    price: "179.00",
    reviews: "1450",
    rating: "4.8",
    image: "/img/105.jpg",
    images: ["/img/105.jpg"],
    description: [
      "Compact sconce with a rounded glass shade and slender metal arm for elegant bedside light.",
      "Soft, warm illumination perfect for reading nooks or hallway accents.",
      "Available in multiple finishes to coordinate with bath and vanity fixtures.",
      "Easy-to-install backplate and standard bulb compatibility.",
      "Engineered for consistent finishes and long-term performance.",
    ],
    Features: [
      "Rounded glass shade",
      "Slim metal arm",
      "Standard medium base socket",
      "Coordinating finish options",
      "Includes installation hardware",
    ],
  },
  {
    id: 6,
    name: "Keller Cabinet Collection ",
    category: "Cabinetry",
    price: "2490.00",
    reviews: "860",
    rating: "4.6",
    image: "/img/106.jpg",
    images: ["/img/106.jpg"],
    description: [
      "Complete cabinet collection crafted with solid wood construction and hand-applied finishes.",
      "Designed for kitchens and bathrooms with modular sizes and custom hardware options.",
      "Soft-close drawers and dovetail joinery ensure durability and premium function.",
      "Available in multiple door styles and paint or stain finishes to suit your project.",
      "Professional installation recommended for full cabinetry runs.",
    ],
    Features: [
      "Solid wood face frames",
      "Soft-close undermount drawers",
      "Multiple finish options",
      "Customizable hardware choices",
      "Durable dovetail joinery",
    ],
  },
  {
    id: 7,
    name: "Keller Drawer Pull",
    category: "Hardware",
    price: "6.99",
    reviews: "1020",
    rating: "4.7",
    image: "/img/107.jpg",
    images: ["/img/107.jpg"],
    description: [
      "Classic drawer pull in solid metal, designed to pair with our Keller cabinetry.",
      "Available in polished and aged finishes to match your kitchen or bathroom hardware.",
      "Comfortable grip and secure mounting screws included for straightforward installation.",
      "Engineered to resist tarnishing and daily wear for long-lasting performance.",
      "A versatile scale that suits both drawers and small doors.",
    ],
    Features: [
      "Solid metal construction",
      "Standard screw spacing",
      "Multiple finish options",
      "Easy installation hardware included",
      "Durable plating to resist wear",
    ],
  },
  {
    id: 8,
    name: "Keller Bin Pull",
    category: "Hardware",
    price: "8.99",
    reviews: "540",
    rating: "4.5",
    image: "/img/108.jpg",
    images: ["/img/108.jpg"],
    description: [
      "Rounded bin pull designed for durability and a refined sightline on cabinet fronts.",
      "Comfortable curve and solid feel make it ideal for frequently used drawers.",
      "Finishes coordinate with our larger Keller collection for a cohesive look.",
      "Supplied with matching screws and clear installation guide.",
      "Engineered for consistent fit with other cabinet hardware.",
    ],
    Features: [
      "Curved ergonomic profile",
      "Durable metal finish",
      "Matching hardware supplied",
      "Coordinates with Keller collection",
    ],
  },
  {
    id: 9,
    name: "Keller Appliance Pull",
    category: "Hardware",
    price: "12.99",
    reviews: "2340",
    rating: "4.9",
    image: "/img/109.jpg",
    images: ["/img/109.jpg"],
    description: [
      "Robust appliance pull sized for dishwashers and large cabinet doors.",
      "Designed to match cabinetry hardware while providing a secure, comfortable grip.",
      "Sturdy mounting points and solid metal construction for frequent use.",
      "Suitable for both contemporary and traditional cabinetry designs.",
      "Can be retrofitted to most appliance faces with standard mounting hardware.",
    ],
    Features: [
      "Heavy-duty metal construction",
      "Extended mounting length",
      "Matching finish options",
      "Easy retrofit for most appliances",
    ],
  },
  {
    id: 10,
    name: "Lorraine Shelf, Rail & Bracket Set",
    category: "Storage",
    price: "119.00",
    reviews: "980",
    rating: "4.7",
    image: "/img/1010.jpg",
    images: ["/img/1010.jpg"],
    description: [
      "Durable shelf and rail kit for displaying kitchenware or organizing pantry items.",
      "Solid bracket supports and clean-lined rail allow flexible styling and storage.",
      "Powder-coated finish for durability in humid kitchen environments.",
      "Easy to install with clear mounting instructions and included hardware.",
      "Modular design allows multiple shelf configurations.",
    ],
    Features: [
      "Solid metal brackets",
      "Powder-coated finish",
      "Includes mounting hardware",
      "Flexible shelf placement",
    ],
  },
  {
    id: 11,
    name: 'Harby Marble Dining Table, 48-60" Round',
    category: "Furniture",
    price: "1599.00",
    reviews: "477",
    rating: "4.8",
    image: "/img/1011.jpg",
    images: ["/img/1011.jpg"],
    description: [
      "Elegant round dining table with a honed marble top and solid wood base.",
      "Expandable design accommodates 48\" to 60\" diameters for flexible dining configurations.",
      "Hand-finished base and quality stone top create a sophisticated focal point.",
      "Ideal for intimate dinners or larger gatherings when extended.",
      "Requires careful placement and simple maintenance to preserve the stone surface.",
    ],
    Features: [
      "Honed marble top",
      "Expandable leaf mechanism",
      "Solid wood base",
      "Protective underside glides",
    ],
  },
  {
    id: 12,
    name: "Lenwood Bed ",
    category: "Furniture",
    price: "1299.00",
    reviews: "159",
    rating: "4.6",
    image: "/img/1012.jpg",
    images: ["/img/1012.jpg"],
    description: [
      "Classic upholstered bed with a softly curved headboard and supportive slat system.",
      "Made with kiln-dried frame and premium upholstery options for long-lasting comfort.",
      "Available in multiple sizes and fabric finishes to fit your bedroom scheme.",
      "Easy assembly with included hardware and clear instructions.",
      "Designed for both traditional and contemporary interiors.",
    ],
    Features: [
      "Upholstered headboard",
      "Durable kiln-dried frame",
      "Replaceable slat system",
      "Available fabric options",
    ],
  },
  {
    id: 13,
    name: 'Del Rey Extendable Dining Table, 88-112"',
    category: "Furniture",
    price: "2199.00",
    reviews: "3010",
    rating: "4.9",
    image: "/img/1013.jpg",
    images: ["/img/1013.jpg"],
    description: [
      "Extendable dining table that grows from 88\" to 112\" to accommodate larger gatherings.",
      "Precision extension slides and solid construction ensure a stable dining surface.",
      "Refined finish options and sculpted leg details make it a design-forward statement piece.",
      "Engineered for longevity with simple maintenance and occasional refinishing.",
    ],
    Features: [
      "Extendable leaf system",
      "Solid hardwood construction",
      "Multiple finishes available",
      "Sturdy, engineered extension slides",
    ],
  },
  {
    id: 14,
    name: "Osbourne Chair",
    category: "Furniture",
    price: "399.00",
    reviews: "1240",
    rating: "4.6",
    image: "/img/1014.jpg",
    images: ["/img/1014.jpg"],
    description: [
      "Timeless lounge chair with a supportive seat and turned wooden legs.",
      "Upholstered in luxurious fabrics with welt trim for an elevated look.",
      "Comfort-forward design that complements living rooms and reading nooks.",
      "Built to last with a kiln-dried hardwood frame and quality foam seating.",
    ],
    Features: [
      "Kiln-dried hardwood frame",
      "Premium upholstery options",
      "Comfort foam cushions",
      "Classic turned leg silhouette",
    ],
  },
  {
    id: 15,
    name: "Del Rey Dining Chair",
    category: "Furniture",
    price: "149.00",
    reviews: "660",
    rating: "4.5",
    image: "/img/1015.jpg",
    images: ["/img/1015.jpg"],
    description: [
      "Sculpted dining chair with mortise-and-tenon construction for strength.",
      "Comfortable contoured seat and supportive back for extended dining comfort.",
      "Available in stained and painted finishes to suit a variety of tables.",
      "Durable finish and easy maintenance for everyday use.",
    ],
    Features: [
      "Mortise-and-tenon joinery",
      "Contoured wood seat",
      "Finish options available",
      "Durable construction",
    ],
  },
  {
    id: 16,
    name: "Maverick Bronze Sconce",
    category: "Lighting",
    price: "189.00",
    reviews: "1310",
    rating: "4.6",
    image: "/img/1016.jpg",
    images: ["/img/1016.jpg"],
    description: [
      "Bronze-finished wall sconce with classic detailing and a warm patina.",
      "Designed to provide flattering task and accent lighting in hallways and baths.",
      "Durable metal construction with mounting hardware included.",
      "Coordinates with other bronze fixtures for a cohesive scheme.",
    ],
    Features: [
      "Bronze finish",
      "Durable metal body",
      "LED-compatible",
      "Includes mounting hardware",
    ],
  },
  {
    id: 17,
    name: "Maverick Bronze House Numbers",
    category: "Hardware",
    price: "45.00",
    reviews: "440",
    rating: "4.4",
    image: "/img/1017.jpg",
    images: ["/img/1017.jpg"],
    description: [
      "Solid metal house numbers with a classic profile and weather-resistant finish.",
      "Precision-cast digits ensure a refined curb appeal and long-term durability.",
      "Comes with installation hardware and template for easy mounting.",
      "Available in multiple sizes to suit your entryway scale.",
    ],
    Features: [
      "Weather-resistant finish",
      "Solid metal casting",
      "Includes mounting hardware",
      "Multiple size options",
    ],
  },
  {
    id: 18,
    name: "Vela Bronze Sconce",
    category: "Lighting",
    price: "139.00",
    reviews: "880",
    rating: "4.4",
    image: "/img/1018.jpg",
    images: ["/img/1018.jpg"],
    description: [
      "Slim profile sconce with a bronze finish and opal glass shade for soft glow.",
      "Well-suited for bathrooms, bedrooms, and layered lighting schemes.",
      "Compact footprint makes it ideal for narrow walls or paired mirror lighting.",
      "Easy-to-install backplate and recommended for dimmable LED bulbs.",
    ],
    Features: [
      "Opal glass shade",
      "Bronze finish",
      "LED-compatible",
      "Compact wall footprint",
    ],
  },
  {
    id: 19,
    name: "Davis Mailbox",
    category: "Outdoor",
    price: "129.00",
    reviews: "920",
    rating: "4.7",
    image: "/img/1019.jpg",
    images: ["/img/1019.jpg"],
    description: [
      "Cast-metal mailbox with a traditional profile and durable powder-coat finish.",
      "Generous capacity for letters and small packages with a secure latch.",
      "Weatherproof construction designed to stand up to seasonal elements.",
      "Mounting options for post or wall installations to suit your entryway.",
    ],
    Features: [
      "Powder-coated cast metal",
      "Secure latch",
      "Multiple mounting options",
      "Generous capacity",
    ],
  },
  {
    id: 20,
    name: "No Soliciting Sign",
    category: "Outdoor",
    price: "24.00",
    reviews: "770",
    rating: "4.3",
    image: "/img/1020.jpg",
    images: ["/img/1020.jpg"],
    description: [
      "Classic enamel-look sign with clear lettering to politely deter solicitors.",
      "Weather-resistant materials maintain color and legibility over time.",
      "Compact size fits most mail posts, doors, and entryway fixtures.",
      "Simple installation with included mounting screws or adhesive options.",
    ],
    Features: [
      "Weather-resistant material",
      "Clear enamel-style lettering",
      "Includes mounting hardware",
      "Compact and visible size",
    ],
  },
];

export default productData;


